import useKinerjaHarianRoleContext from 'app/KinerjaHarian/hooks/useKinerjaHarianRoleContext'

import type { KinerjaHarianRole } from 'types/kinerja-harian'

export function useKinerjaHarianRole(): {
  role: KinerjaHarianRole | undefined
} {
  const { role } = useKinerjaHarianRoleContext()
  return { role }
}
